/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type PaymentStatusPendingDto = {
    /**
     * Payment status
     */
    status: PaymentStatusPendingDto.status;
};
export namespace PaymentStatusPendingDto {
    /**
     * Payment status
     */
    export enum status {
        PENDING = 'PENDING',
    }
}

